<div>
  <div class="font-weight-bold text-dark font-size-24">$78.62M</div>
  <div>Paid in Crypto</div>
  <x-chartist [data]="chartData" [type]="'Line'" [options]="chartOptions" class="height-200 ct-hidden-points">
  </x-chartist>
</div>